module.exports = __webpack_public_path__ + "static/media/profile.608d8638.jpg";